<template>
  <DatatableReportV3
    title="Equipment Capture"
    :source="source"
    :config="config"
    :filters="filters"
  />
</template>

<script>
import EquipmentDetailsModal from "@/Equipment/EquipmentDetailsModal.vue";
import DatatableReportV3 from "@/Reports/DatatableReportV3.vue";
import { customerClassificationColumns } from "@/lib/customerTypes";
import store from "@/vuex/store";

export default {
  components: {
    DatatableReportV3
  },
  props: {
    source: {
      type: String,
      default: ""
    },
    filters: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      config: {
        responsive: true,
        bLengthChange: false,
        columns: [
          {
            data: "invoice_date",
            title: "Invoice Date",
            searchable: false,
            responsivePriority: 6
          },
          { data: "invoice_id", title: "Invoice", responsivePriority: 5 },
          { data: "job_id", title: "Job", responsivePriority: 8 },
          { data: "department", title: "Department", responsivePriority: 10 },
          {
            data: "technician",
            title: "Opportunity Owner",
            responsivePriority: 9
          },
          ...customerClassificationColumns(),
          { data: "customer", responsivePriority: 1 },
          { data: "customer_email", title: "Email", responsivePriority: 12 },
          { data: "customer_phone", title: "Phone", responsivePriority: 11 },
          {
            data: "location_name",
            title: "Location Name",
            responsivePriority: 13
          },
          { data: "address", responsivePriority: 14 },
          { data: "line_item", title: "Line Item", responsivePriority: 3 },
          {
            data: "request_type",
            title: "Request Type",
            searchable: false,
            responsivePriority: 7
          },
          {
            data: "equipment_type",
            responsivePriority: 4,
            title: "Equipment Type",
            searchable: false
          },
          { data: "equipment", responsivePriority: 2 }
        ],
        vueComponents: [
          {
            rootId: "equipment-read-only-vue",
            component: EquipmentDetailsModal,
            options: {
              store
            }
          }
        ]
      }
    };
  },
  mounted() {
    this.$store.dispatch("addBreadcrumb", { label: "Equipment Capture" });
  }
};
</script>

<style lang="scss" scoped></style>
